import ConnectedBuilderPage from './ConnectedBuilderPage';

export default ConnectedBuilderPage;
export { ConnectedBuilderPage };
